import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "./api/axios";

import Home from './Pages/Home';
import ProductListing from './Pages/ProductListing';
import ProductDetail from './Pages/ProductDetail';
import Cart from './Pages/Cart';
import Checkout from './Pages/Checkout';
import Login from './Pages/Login';
import Register from './Pages/Register';
import ForgetPass from './Pages/ForgetPass';
import FilterSidebar from './Components/FilterSidebar';
import Privacy from './Pages/Privacy';
import TermsConditions from './Pages/TermsConditions';
import Sale from './Pages/Sale';
import ThankYou from './Pages/ThankYou';
import ScrollToTop from "./Components/ScrollToTop"; //ScrollToTop

import Dashboard from "./UserDashboard/Pages/Dashboard";
import OrderList from "./UserDashboard/Pages/OrderList";
import OrderDetail from "./UserDashboard/Pages/OrderDetail";
import ManageAddress from "./UserDashboard/Pages/ManageAddress";
import Profile from "./UserDashboard/Pages/Profile";
import Support from "./UserDashboard/Pages/Support";
import Wishlist from "./UserDashboard/Pages/Wishlist";
import PurchaseHistory from "./UserDashboard/Pages/PurchaseHistory";


const basename = '';

function App() {
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      axios.get("/profile/counters").catch((err) => {
        console.error("Session verification failed on startup:", err);
      });
      axios.get("/wishlists")
        .then(res => {
          if (res.data && res.data.data) {
            const slugs = res.data.data.map(item => item.product.slug);
            localStorage.setItem("wishlist_slugs", JSON.stringify(slugs));
            window.dispatchEvent(new Event("wishlist-slugs-updated"));
          }
        })
        .catch(err => {
          console.error("Error fetching wishlist on startup:", err);
        });
    }
  }, []);

  return (
    <Router basename={basename}>
       <ScrollToTop />
      <Routes>
        {/* User Front Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductListing />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgetpassword" element={<ForgetPass />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/sale" element={<Sale />} />
        <Route path="/thankyou" element={<ThankYou />} />

        {/* Dashboard pages */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/orderlist" element={<OrderList />} />
        <Route path="/orderdetail" element={<OrderDetail />} />
        <Route path="/manageaddress" element={<ManageAddress />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/support" element={<Support />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/purchasehistory" element={<PurchaseHistory />} />



      </Routes>
    </Router>
  );
}

export default App;
